import { getAuthHeaders } from '../actions/authActions';
import tempMeeApi from '../apis/tempMee';

export const getCredentialsV2 = async (userId, userType) => {
  const headers = await getAuthHeaders();

  return tempMeeApi.get(`credential-service/users/${userId}/credentials`, {
    params: {
      userType,
    },
    headers: {
      ...headers,
    },
  });
};

export const patchCredentials = async (userId, education, insurances) => {
  const headers = await getAuthHeaders();

  return tempMeeApi.patch(
    `admin/users/${userId}/specialtiesAndProcedures`,
    { education, insurances },
    { headers },
  );
};

export const patchCredentialsV2 = async (userId, userType, education, insurances, softwares) => {
  const headers = await getAuthHeaders();

  return tempMeeApi.patch(
    `credential-service/users/${userId}/credentials?userType=${userType}`,
    {
      education,
      insurances,
      ...(softwares && { softwares }),
    },
    { headers },
  );
};

/** get prof licenses from monolith with secure s3 image url */ 
export const getProtectedProfLicenses = async (userId) => {
  const headers = await getAuthHeaders();
  return tempMeeApi.get(`admin/users/${userId}/licenses`, { headers });
};


export const getProfessionalAttestation = async (userId, code) => {
  const headers = await getAuthHeaders();
  return tempMeeApi.get(`credential-service/users/${userId}/consents/${code}`, {
    headers,
  });
};

export const getDentistAttestation = async (officeId, code) => {
  const headers = await getAuthHeaders();
  return tempMeeApi.get(`credential-service/admin/consents/${code}`, {
    headers,
    params: {
      office_id: officeId
    }
  });
};

export const updateDentistAttestation = async ({ officeId, code, isEnabled }) => {
  const headers = await getAuthHeaders();
  return tempMeeApi.patch(
    `credential-service/admin/consents/${code}`, 
    { is_enabled: isEnabled },
    {
      headers,
      params: {
        office_id: officeId
      }
    },
  );
};